import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardActions, CardContent, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { MediaCard, LinkButton } from '../../../../../../../components';
import TermsAndConditionDisableUserModal from '../../TermsAndConditionDisableUserModal/TermsAndConditionDisableUserModal';
import * as UserActions from '../../../../../../../core/users/action';
import * as VendorEventActions from '../../../../../../../core/vendor-events/action';
import AvatarImg from '../../../../../../../assets/svg/user_circle.svg';
import { APP_ROUTES } from '../../../../../../../constants/app-routes';

export default function VendorsList({ usersVendorList }) {
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(null);
  const [displayModalDisableUser, setDisplayModalDisableUser] = useState(false);
  const { eventList } = useSelector((store) => store.vendorEvents);

  const navigateToDetails = (vendorId = null) => {
    if (vendorId === undefined) return '';
    return APP_ROUTES?.VENDOR_PUBLIC_PROFILE.replace(':vendorId', vendorId);
  };

  const onCloseModal = () => setDisplayModalDisableUser(false);

  const onOpenModalDisableUser = (user) => {
    if (user) {
      setSelectedUser(user);
      setDisplayModalDisableUser(true);
      dispatch(VendorEventActions.getVendorEventsWithoutFilters(user.id));
    }
  };

  const onDisableUser = (eventId, message) => {
    if (selectedUser && eventId && message) {
      dispatch(UserActions.disableUserByTermsAndConditions(message, selectedUser.id, eventId));
      onCloseModal();
    }
  };

  const getUserStatus = (user) => {
    if (user.state === 'ACTIVE')
      return (
        <div className="status-event">
          <p className="status-event__label" style={{ background: 'green' }}>
            {' '}
            Active
          </p>
        </div>
      );
    if (user.state === 'INACTIVE') {
      return (
        <div className="status-event">
          <p className="status-event__label" style={{ background: 'gray' }}>
            {' '}
            Disabled
          </p>
        </div>
      );
    }
    if (user.state === 'NO APPROVED') {
      return (
        <div className="status-event">
          <div className="status-event__container">
            <p className="status-event__label" style={{ background: '#0997ba', marginLeft: -1 }}>
              {' '}
              No Approved
            </p>
          </div>
        </div>
      );
    }
    return '';
  };
  return (
    <Grid container justifyContent="start" marginTop={5}>
      {displayModalDisableUser && (
        <TermsAndConditionDisableUserModal
          isOpen={displayModalDisableUser}
          handleClose={onCloseModal}
          onDisableUser={onDisableUser}
          eventList={eventList}
          info={{ user: selectedUser }}
        />
      )}

      {usersVendorList?.map((row) => (
        <Grid key={uuidv4()} item p={2}>
          <MediaCard key={row.id} image={AvatarImg}>
            {getUserStatus(row)}
            <CardContent>
              <Typography variant="h6" fontWeight="bold" component="div">
                {row?.name || '-'}
              </Typography>
              <Typography gutterBottom variant="caption" color="text.secondary">
                {row?.email || '-'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {row?.vendor_business_desc || '-'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {row?.vendor_product_desc || '-'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {row?.vendor_company_name || '-'}
              </Typography>
            </CardContent>
            <CardActions>
              <LinkButton to={navigateToDetails(row.id)} variant="text">
                View Details
              </LinkButton>
              <Button
                disabled={row.state === 'INACTIVE'}
                size="small"
                onClick={() => onOpenModalDisableUser(row)}>
                Disable
              </Button>
            </CardActions>
          </MediaCard>
        </Grid>
      ))}
    </Grid>
  );
}

VendorsList.propTypes = {
  usersVendorList: PropTypes.arrayOf.isRequired,
};
